module.exports = __webpack_public_path__ + "static/Recruit01_02-3c62694524be12b257ec399d5506f157.png";